import React, { Component } from "react";
import { connect } from 'react-redux';
import * as actionCreators from 'store/actions'

class WindowResizer extends Component {
    constructor(props){
        super(props)
        this.state = { width: 0, height: 0, window: null };
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.addEventListener("resize", this.updateWindowDimensions);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateWindowDimensions);
    }

    updateWindowDimensions = () => {
        // console.log(window.innerWidth)
        this.props.setWindow(window, window.document.body)
        this.setState({ width: window.innerWidth, height: window.innerHeight, window: window, body: window.document.body }, () => {
            // console.log('WindowSize', { width: window.innerWidth, height: window.innerHeight, window: window, body: window.document.body })
        });
    };

    render() {
        return (
            <div
                window={this.state}
            >
                {this.props.children}
            </div>
        );
    }
};

const mapStateToProps = state => {
    return {
        
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setWindow: (window, body) => dispatch(actionCreators.setWindow(window,body))
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( WindowResizer );
